import { useEffect, useRef, useState } from "react";
import { Award, Compass, Settings, Zap, ShieldCheck, Leaf, ChevronDown } from "lucide-react";

const values = [
{
  icon: Award,
  title: "Ingeniørerfaring",
  desc: "Vi har solid erfaring med prosjektering og teknisk planlegging. Med ingeniørkompetanse internt kan vi tilpasse konstruksjonen til ulike forhold over hele Norge. Før levering vurderer vi blant annet lokasjon, snølast, vindlast og andre lokale krav. Deretter tilpasses konstruksjonen slik at badstuen er bygget riktig for stedet den skal stå, enten det er ved sjøen, i skogen eller på fjellet."
},
{
  icon: Compass,
  title: "Skreddersydde prosjekter",
  desc: "Alle badstuene våre er nøye prosjektert og håndlaget med stor presisjon. Samtidig er det de skreddersydde prosjektene vi liker aller best, fordi ingen løsninger blir helt like. På den måten kan du tilpasse størrelse på rommene, planløsning, materialer, farger og funksjoner slik at badstuen passer akkurat dine behov og omgivelsene den skal stå i"
},
{
  icon: Settings,
  title: "KS – kvalitetssystem",
  desc: "Etter mange år i byggebransjen som totalentreprenør i Oslo har vi bygget opp et solid system for kvalitetssikring. Fra materialvalg og tekniske løsninger til produksjon og ferdigstillelse følger vi faste rutiner som sikrer at alt blir gjort ordentlig. Det handler om å ha kontroll på detaljene gjennom hele prosessen."
},
{
  icon: Zap,
  title: "Klar på 5–10 uker",
  desc: "Produksjonstiden varierer litt avhengig av sesong, kapasitet og leveringstid på materialer. Uansett følger vi alltid den samme gjennomarbeidede prosessen i produksjonen. Hver badstue bygges med fokus på kvalitet, presisjon og kontroll i alle ledd, slik at sluttresultatet holder den standarden vi ønsker å levere."
},
{
  icon: ShieldCheck,
  title: "Med 5 års garanti",
  desc: "Basert på kvaliteten vi leverer, kan vi trygt tilby full 5 års garanti på våre badstuer. Det er ikke så vanlig i markedet, men vi stoler på løsningene våre, materialene vi bruker og måten vi bygger på. Badstuene er laget for nordiske forhold og bygget for å vare i mange år."
},
{
  icon: Leaf,
  title: "Transport i én modul",
  desc: "Badstuen bygges ferdig som én komplett modul i verkstedet vårt og leveres ferdigmontert til ønsket lokasjon. Det gjør installasjonen raskere, enklere og gir oss bedre kontroll på kvaliteten gjennom hele byggeprosessen."
}];


const ValueCard = ({ value, index, visible }) => {
  const [expanded, setExpanded] = useState(false);
  const sentences = value.desc.split('. ');
  const preview = sentences.slice(0, Math.ceil(sentences.length / 2)).join('. ') + (sentences.length > 2 ? '.' : '');
  
  return (
    <div
      className={`transition-all duration-700 group cursor-pointer hover:bg-secondary/30 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
      style={{ transitionDelay: `${index * 100}ms` }}>
      <value.icon size={22} strokeWidth={1} className="text-primary mb-5 group-hover:text-primary/80 transition-colors" />
      <h3 className="font-heading text-xl md:text-2xl mb-3 group-hover:text-foreground/80 transition-colors">{value.title}</h3>
      <div className="text-foreground/60 font-body leading-relaxed group-hover:text-foreground/80 transition-colors" style={{ fontSize: "23px" }}>
        {expanded ? value.desc : preview}
      </div>
      {sentences.length > 2 && (
        <button
          onClick={() => setExpanded(!expanded)}
          className="mt-3 inline-flex items-center gap-1 px-0 py-2 text-foreground text-sm font-body uppercase tracking-widest-xl">
          {expanded ? 'Vis mindre' : 'Les mer'}
          <ChevronDown size={16} className={`transition-transform ${expanded ? 'rotate-180' : ''}`} />
        </button>
      )}
    </div>
  );
};

export default function ValuesSection() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {if (entry.isIntersecting) setVisible(true);},
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-24 md:py-40">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="text-center mb-20">
          <p className="tracking-widest-2xl font-body uppercase text-primary mb-6" style={{ fontSize: "23px" }}>
            Hvorfor velge LYKKE
          </p>
          <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-light">
            Fordi vi trives med godt håndverk.
            <br />
            <span className="italic">Enkelt og greit.</span>
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-16">
          {values.map((v, i) => <ValueCard key={i} value={v} index={i} visible={visible} />)}
        </div>
      </div>
    </section>);

}